// Copyright (c) Move Closer 2022.

/**
 * @author Łukasz Sitnicki <lukasz.sitnicki@movecloser.pl>
 */
export class Degree {
  constructor (public value: number) {
  }

  /**
   * Converts stored degrees to radians.
   */
  toRadians () {
    return (this.value * Math.PI) / 180
  }
}

/**
 * @author Łukasz Sitnicki <lukasz.sitnicki@movecloser.pl>
 */
export class Point {
  protected _lat: Degree
  protected _lng: Degree

  constructor (lat: number, lng: number) {
    this._lat = new Degree(lat)
    this._lng = new Degree(lng)
  }

  /**
   * Get latitude.
   */
  get lat () {
    return this._lat.value
  }

  /**
   * Set new value for latitude Degree instance.
   */
  set lat (val: number) {
    this._lat.value = val
  }

  /**
   * Get longitude.
   */
  get lng () {
    return this._lng.value
  }

  /**
   * Set new value for longitude Degree instance.
   */
  set lng (val: number) {
    this._lng.value = val
  }

  /**
   * Get instance of Degree for latitude.
   */
  get x () {
    return this._lat
  }

  /**
   * Get instance of Degree for longitude.
   */
  get y () {
    return this._lng
  }

  /**
   * Returns latitude and longitude as array.
   */
  toArray () {
    return [
      this.lat,
      this.lng
    ]
  }
}
